import { takeEvery, put, call } from 'redux-saga/effects';
import { GET_SSO_ERROR_URL, DEFAULT_BASE_URL } from '../../shared/api/urls';
import { apiPost } from '../../shared/api';
import { GET_SSO_LOGIN_ERROR } from '../../actions/actionTypes';
import { POST } from '../../shared/api/httpMethods';
import { showErrorStatusAction } from '../../shared/actions/actionCreators';
import FormDatafy from '../../shared/utils/FormDataUtil/FormDataUtil';

function* getSSOErrorAsync() {
    const postConfig = {
        baseURL: DEFAULT_BASE_URL,
        method: POST,
        url: GET_SSO_ERROR_URL,
    };
    try {
        const { data } = yield call(apiPost, FormDatafy({}), postConfig);
        if (data) {
            yield put(showErrorStatusAction(404, data.errorMessage));
        }
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(error);
    }
}

export default function* watchGetSSOError() {
    yield takeEvery(GET_SSO_LOGIN_ERROR, getSSOErrorAsync);
}
